<sirius-container>
    @if (resolvedHeadline()) {
        <sirius-heading
            class="sir-accordion-headline"
            [h]="2"
            [text]="resolvedHeadline()"
            textStyleCategory="title"
            textStyleSize="xl"
        ></sirius-heading>
    }

    <!-- The rule that opens the list sits on this wrapper rather than the host, so a headline
         renders above it instead of between it and the first row. -->
    <div class="sir-accordion-list">
        @if (resolvedItems().length) {
            @for (item of resolvedItems(); track item.id || i; let i = $index) {
                <sirius-accordion-item
                    [title]="item.title"
                    [headingId]="item.id"
                    [regionId]="item.id ? item.id + '-panel' : undefined"
                    [expanded]="isOpen(i)"
                    (expandedChange)="toggle(i, $event)"
                >
                    <sirius-text-html [html]="item.body"></sirius-text-html>
                </sirius-accordion-item>
            }
        }

        <ng-content></ng-content>
    </div>
</sirius-container>
